import EventType from '@src/model/agentChatEventType';

// Event types handled through the regular agent-console path of `handleAgentEvent`; any other
// type is only processed by its dedicated early branch, or dropped.
const AGENT_EVENT_TYPES: string[] = [
  EventType.NEW_CHAT.id,
  EventType.AGENT_PICKED_UP_CHAT.id,
  EventType.CHAT_FORCED_ASSIGNED_TO_AGENT.id,
  EventType.INCOMING_MESSAGE.id,
  EventType.AI_FOLLOWUP_MESSAGE.id,
  EventType.CONTACT_CLOSED_CHAT.id,
  EventType.CONTACT_LEFT_CHAT.id,
  EventType.REOPENED_CHAT.id,
  EventType.OUT_MESSAGE_DELIVERY_CONFIRMED.id,
  EventType.OUT_MESSAGE_DELIVERY_FAILED.id,
  EventType.OUT_MESSAGE_RECEIPT.id,
  EventType.OUT_MESSAGE_READ.id,
  EventType.INCOMING_REACTION.id,
  EventType.OUTGOING_MESSAGE.id,
  EventType.XFER_REQUESTED.id,
  EventType.XFER_CANCELLED.id,
  EventType.XFER_REJECTED.id,
  EventType.XFER_ACCEPTED.id,
  EventType.NEW_CONVERSATION.id,
  EventType.NEW_AUTOMATIC_MESSAGE.id,
  EventType.CHAT_PIN_TOGGLED.id,
  EventType.CHAT_TAKEN_MESSAGE.id,
  EventType.CHAT_ASSIGNED.id,
  EventType.CHAT_ASSIGN_MESSAGE.id,
  EventType.AGENT_CLOSED_CHAT.id,
];

const isAgentEvent = (type: string): boolean =>
  AGENT_EVENT_TYPES.includes(type);

export default isAgentEvent;
